/**
 * Created by pzf on 2018/10/31
 *
 */
import React, { useState, useMemo, useEffect, useRef, useCallback, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'mkui-fd';
import { getColSpan, mapPropsToFields as _mapPropsToFields } from './util';
import FieldItem from './FieldItem';

function DynamicForm(props, ref) {
  var layout = props.layout,
      gutter = props.gutter,
      fields = props.fields,
      columnNumber = props.columnNumber,
      form = props.form,
      value = props.value;
  useImperativeHandle(ref, function () {
    return {
      validate: function validate() {
        return _validate();
      }
    };
  });

  var _validate = function _validate() {
    return new Promise(function (reslove, reject) {
      form.validateFields(function (err) {
        if (err) {
          return reject(err);
        }

        reslove();
      });
    });
  };

  var renderItems = function renderItems() {
    return fields.map(function (item) {
      return React.createElement(Col, {
        span: getColSpan(item.size, columnNumber),
        key: item.property.name
      }, React.createElement(FieldItem, {
        field: item,
        gutter: gutter,
        form: form
      }));
    });
  };

  return React.createElement(Form, {
    layout: layout
  }, React.createElement(Row, {
    gutter: gutter
  }, renderItems()));
}
/** *******************static************************** */


DynamicForm.propTypes = {
  fields: PropTypes.array,
  layout: PropTypes.string,
  gutter: PropTypes.number,
  columNumber: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.object
};
DynamicForm.defaultProps = {
  fields: [],
  layout: 'vertical',
  gutter: 24,
  columnNumber: 2
};
export default Form.create({
  mapPropsToFields: function mapPropsToFields(props) {
    return _mapPropsToFields(props.value, props.fields);
  },
  onValuesChange: function onValuesChange(props, values) {
    if (props.onChange) {
      props.onChange(values);
    }
  }
})(forwardRef(DynamicForm));
//# sourceMappingURL=DynamicForm.js.map
